<template>
    <div>
          <!----- Header Title ----->
      <div class="row">
        <div class="col-md-3">
          <div>
            <h3 class="page-title mb-1">
                  {{ this.$route.meta.title }}
            </h3>
          </div>
          <div class="breadcrumb-container">
            <ul class="uk-breadcrumb">
              <li><span>Admin</span></li>
              <li><a href="">{{ this.$route.meta.title }}</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-9 relative">
            <div class="grey-box">
                <div class="d-inline-block mt-5">
                    <DateRange style="float: none;" @dateChange="dateChange" />
                    <!-- <div class="mt-4">
                        <ul class="filter d-md-inline-flex d-none">
                            <li v-for="(day, dayIndex) in dayMenus" 
                                :key="dayIndex" 
                                :class="dayIndex | isActive(filters.day)" 
                                @click="filter(dayIndex)"
                            >
                            <a href="#">{{ day }}</a>
                            </li>
                        </ul>
                    </div> -->
                </div>
                <div class="d-inline-block pr-3">
                    <div class="text-right">
                    <router-link :to="'/vehicles/new'">
                        <a  class="outline-btn pt-1" style="padding: 5px 10px;">
                            <i class="far fa-file-pdf mr-2"></i> Download
                        </a>
                    </router-link>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-8 mb-3">
          <ul class="filter d-md-inline-flex d-none">
            <li class="active">
              <a  @click="filterType('')">Invoice</a>
            </li>
            <li>
              <a @click="filterType('')">Commission</a>
            </li>
          </ul>
        </div>
        <div class="col-md-4 relative">
          <div class="uk-position-bottom-right pr-3">
            <div class="mb-3 text-right">
              <router-link class="mr-2" :to="'/availability/reservation/'">
                <a class="outline-btn"><i class="fal fa-calendar mr-2"></i>Availability Check</a>
              </router-link>
              <router-link :to="'/new/reservation/'">
                <a class="outline-btn"><i class="fal fa-calendar-check mr-2"></i>New Reservation</a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
            <div class="col-md-6 text-left">
            <h5 class="mt-1 mb-2 uk-text-bold">Invoice</h5>
            </div>
        </div>
      <div class="table-responsive">
        <table class="table data-table table-round table-hover">
          <thead>
            <tr>
                <th>
                    Reservation No.
                    <Sort column="id" />
                </th>
                  <th>
                    Client
                  </th>
                  <th>
                    Pick-up Date
                  </th>
                  <th>
                    Return Date
                  </th>
                  <th>
                    Days Rented
                  </th>
                  <th>
                    Commission Type
                  </th>
                  <th>
                    Reservation Status
                  </th>
                  <th>
                    Discount Amount
                  </th>
                <th>
                    Commission Status
                </th>
                <th>
                    Commissionable Amount
                </th>
                <th>
                    Commission Percentage
                </th>
                <th>
                    Percentage Discount
                </th>
                <th>
                    Final Percentage
                </th>
                <th>
                    Commission Amount
                </th>
                <th>
                    Total Revenue
                </th>
                <th>
                    Total Price
                </th>
            </tr>
          </thead>
          <tbody>
                <tr>
                  <td>12</td>
                  <td>Hanah Salazar</td>
                  <td>27-12-2023 12:59</td>
                  <td>08-01-2024 12:59</td>
                  <td>12</td>
                  <td>Invoice</td>
                  <td>Completed</td>
                  <td class="text-right">$ 1,179.00</td>
                  <td>Open</td>
                  <td>$ 1,953.00</td>
                  <td>20%</td>
                  <td>0%</td>
                  <td>20%</td>
                  <td class="text-right">$ 390.60</td>
                  <td class="text-right">$ 380.60</td>
                  <td class="text-right">$ 340.60</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Hanah Salazar</td>
                  <td>27-12-2023 12:59</td>
                  <td>08-01-2024 12:59</td>
                  <td>12</td>
                  <td>Invoice</td>
                  <td>Completed</td>
                  <td class="text-right">$ 1,179.00</td>
                  <td>Open</td>
                  <td>$ 1,953.00</td>
                  <td>20%</td>
                  <td>0%</td>
                  <td>20%</td>
                  <td class="text-right">$ 390.60</td>
                  <td class="text-right">$ 380.60</td>
                  <td class="text-right">$ 340.60</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Hanah Salazar</td>
                  <td>27-12-2023 12:59</td>
                  <td>08-01-2024 12:59</td>
                  <td>12</td>
                  <td>Invoice</td>
                  <td>Completed</td>
                  <td class="text-right">$ 1,179.00</td>
                  <td>Open</td>
                  <td>$ 1,953.00</td>
                  <td>20%</td>
                  <td>0%</td>
                  <td>20%</td>
                  <td class="text-right">$ 390.60</td>
                  <td class="text-right">$ 380.60</td>
                  <td class="text-right">$ 340.60</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Hanah Salazar</td>
                  <td>27-12-2023 12:59</td>
                  <td>08-01-2024 12:59</td>
                  <td>12</td>
                  <td>Invoice</td>
                  <td>Completed</td>
                  <td class="text-right">$ 1,179.00</td>
                  <td>Open</td>
                  <td>$ 1,953.00</td>
                  <td>20%</td>
                  <td>0%</td>
                  <td>20%</td>
                  <td class="text-right">$ 390.60</td>
                  <td class="text-right">$ 380.60</td>
                  <td class="text-right">$ 340.60</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Hanah Salazar</td>
                  <td>27-12-2023 12:59</td>
                  <td>08-01-2024 12:59</td>
                  <td>12</td>
                  <td>Invoice</td>
                  <td>Completed</td>
                  <td class="text-right">$ 1,179.00</td>
                  <td>Open</td>
                  <td>$ 1,953.00</td>
                  <td>20%</td>
                  <td>0%</td>
                  <td>20%</td>
                  <td class="text-right">$ 390.60</td>
                  <td class="text-right">$ 380.60</td>
                  <td class="text-right">$ 340.60</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Hanah Salazar</td>
                  <td>27-12-2023 12:59</td>
                  <td>08-01-2024 12:59</td>
                  <td>12</td>
                  <td>Invoice</td>
                  <td>Completed</td>
                  <td class="text-right">$ 1,179.00</td>
                  <td>Open</td>
                  <td>$ 1,953.00</td>
                  <td>20%</td>
                  <td>0%</td>
                  <td>20%</td>
                  <td class="text-right">$ 390.60</td>
                  <td class="text-right">$ 380.60</td>
                  <td class="text-right">$ 340.60</td>
                </tr>
              </tbody>
              <!-- <tfoot>
                <tr>
                    <td>TOTAL</td>
                </tr>
              </tfoot> -->
          <tfoot>
          </tfoot>
        </table>
      </div>

      <!-- PAGINATION -->
      <div class="card-footer pb-0 pt-3" v-if="numberOfPage > 1">
            <jw-pagination
              :items="pages"
              @changePage="onChangePage"
              :pageSize="limit"
              :styles="customStyles"
              :labels="customLabels"
            ></jw-pagination>
          </div>
    </div>
    
  </template>
  
  
  
  <script>

  export default {
    
  }
  </script>
  
  <style scoped>
  .card-footer {
    text-align: right;
    position: relative;
    background: #fff;
  }
  .pagination {
    top: 20px;
    position: absolute;
    right: 0px;
    align-content: flex-end;
    text-align: end;
  }
  .grey-box {
  float: right; 
  background-color: transparent; 
  box-shadow: none; 
  border: none; 
  padding: 10px 0
}
.d-inline-block {
    display: inline-block;
}
  </style>